// extracted by mini-css-extract-plugin
export default {"skillsCommunityStatus":"style_skillsCommunityStatus__p6f-E","skillsItem":"style_skillsItem__-q8ZD","tags":"style_tags__B9mN3","edit":"style_edit__QsBRV"};